import styled, { css } from 'styled-components';

const StyledButton = styled.button(
  ({ theme }) => css`
    background: none;
    border: none;
    border-bottom: 1px solid ${theme.border.default};
    color: ${theme.text.default};
    padding: 0.125rem;
    font: inherit;
    cursor: pointer;
    font-size: 1rem;
    transition: all 0.1s ease;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    text-wrap: nowrap;

    &:hover {
      border-bottom: 1px solid ${theme.paper.default};
      transform: scale(1.05);
    }

    &:focus-visible {
      outline: 1px solid ${theme.border.focus};
      outline-offset: 2px;
    }

    @media (max-width: 630px) {
      font-size: 0.8rem;
    }
  `
);

export interface LinkButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export function LinkButton({ children, ...rest }: LinkButtonProps) {
  return <StyledButton {...rest}>{children}</StyledButton>;
}
